export const formatDate = (dateString: string | undefined): string => {
  if (!dateString) return ''

  try {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    })
  } catch {
    return ''
  }
}

export const getMonthYear = (dateString: string | undefined): string => {
  if (!dateString) return ''

  try {
    return new Date(dateString).toLocaleDateString('en-US', {
      month: 'long',
    })
  } catch {
    return ''
  }
}
